//

// ******************************************************************
// * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. *
// ******************************************************************

import { DiscoveryApi } from '../types/discovery';
import { FetchApi } from '../types/fetch';
import crossFetch from 'cross-fetch';
import { pluginId } from '../pluginId';
import * as parser from 'uri-template';
import { IsItOpenEnvironment } from '../models/IsItOpenEnvironment.model';
import { IsItOpenHttpRequest } from '../models/IsItOpenHttpRequest.model';
import { IsItOpenMqttRequest } from '../models/IsItOpenMqttRequest.model';
import { IsItOpenResponse } from '../models/IsItOpenResponse.model';
import { IsItOpenTcpRequest } from '../models/IsItOpenTcpRequest.model';

/**
 * Wraps the Response type to convey a type on the json call.
 *
 * @public
 */
export type TypedResponse<T> = Omit<Response, 'json'> & {
  json: () => Promise<T>;
};

/**
 * Options you can pass into a request for additional information.
 *
 * @public
 */
export interface RequestOptions {
  token?: string;
}
/**
 * @public
 */
export type GetIsItOpenEnvironments = {};
/**
 * @public
 */
export type PostIsItOpenCheckHttp = {
  body: IsItOpenHttpRequest;
};
/**
 * @public
 */
export type PostIsItOpenCheckMqtt = {
  body: IsItOpenMqttRequest;
};
/**
 * @public
 */
export type PostIsItOpenCheckTcp = {
  body: IsItOpenTcpRequest;
};

/**
 * @public
 */
export class DefaultApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  /**
   * Returns kubernetes clusters the authenticated user can access
   * Get user-allowed environments
   */
  public async getIsItOpenEnvironments(
    // @ts-ignore
    request: GetIsItOpenEnvironments,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<IsItOpenEnvironment>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/environments`;

    const uri = parser.parse(uriTemplate).expand({});

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * Probe HTTP(S) connectivity from a cluster
   * @param isItOpenHttpRequest -
   */
  public async postIsItOpenCheckHttp(
    // @ts-ignore
    request: PostIsItOpenCheckHttp,
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/check/http`;

    const uri = parser.parse(uriTemplate).expand({});

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'POST',
      body: JSON.stringify(request.body),
    });
  }

  /**
   * Probe MQTT connectivity from a cluster
   * @param isItOpenMqttRequest -
   */
  public async postIsItOpenCheckMqtt(
    // @ts-ignore
    request: PostIsItOpenCheckMqtt,
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/check/mqtt`;

    const uri = parser.parse(uriTemplate).expand({});

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'POST',
      body: JSON.stringify(request.body),
    });
  }

  /**
   * Probe TCP connectivity from a cluster
   * @param isItOpenTcpRequest -
   */
  public async postIsItOpenCheckTcp(
    // @ts-ignore
    request: PostIsItOpenCheckTcp,
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/check/tcp`;

    const uri = parser.parse(uriTemplate).expand({});

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'POST',
      body: JSON.stringify(request.body),
    });
  }
}
